import React from 'react'
import styled from 'styled-components'

const SSPan = styled.span`
    display: flex;
    align-items: center;
`

interface ICalendarIconProps {
    className?: string
    fill?: string
    dataTestid?: string
    size?: number
    title?: string
    id?: string
    onMouseEnter?: () => void
    onMouseLeave?: () => void
}

export function ClockIcon({
    fill,
    size = 14,
    title,
    dataTestid,
    id = 'clock-icon',
}: ICalendarIconProps): React.ReactElement {
    return (
        <SSPan title={title} id={id} data-testid={dataTestid}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill ?? 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-clock"
            >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
        </SSPan>
    )
}
